export interface SignatureResponse {
    sdkCommunicationMessage: any;
    signatureId: string;
}

export interface SignatureResponseWithoutWallet {
    signatureId: string;
}
